export default __webpack_public_path__ + "static/media/arrow-down-orange.224a89f1.svg";